<!-- 设置显示及语言 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                   parkCode:"2KPGDYCO",
                   customVipSeq:"",
                   customCode:"002",
                   showMsgList: [{
                        "showChannelType": "0",
                        "showPassMode": "0",
                        "showSafeMode":"0",
                        "textMessage": "%P欢迎光临",
                        "voiceMessage": "%P欢迎光临",
                        "timeperiodType": "0",
                        "isCharge":"0",
                        "lastOperator":"张三",
                        "lastOperateTime": "2017-12-01 00:00:00"
                    },{
                        "showChannelType": "0",
                        "showPassMode": "0",
                        "showSafeMode":"0",
                        "textMessage": "%P欢迎光临",
                        "voiceMessage": "%P欢迎光临",
                        "timeperiodType": "0",
                        "isCharge":"0",
                        "lastOperator":"李四",
                        "lastOperateTime": "2017-12-01 00:00:00"
                    }]
            },
            responseCode: {
                "data": {

                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台设置VIP基本类型显示以及语言播报",
                t_url: this.commonUrls.test+"setVipShowMsg",
                p_url: this.commonUrls.prod+"setVipShowMsg",
                precondition: "VEMS 2.16及以上版本",
                fitSystem: "VEMS传统停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'customVipSeq', info2: 'customVipSeq和customCode必填写一个,优先使用customVipSeq', info3: 'Integer', info4: 'vip类型Seq' },
                        { info1: 'customCode', info2: 'customVipSeq和customCode必填写一个,优先使用customVipSeq', info3: 'String', info4: '自定义编码' },
                        { info1: 'showMsgList', info2: '是', info3: 'JSONArray', info4: '显示及语音列表' }
                        ]
                },{
                    titleName: "showMsgList",
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'showChannelType', info2: '是', info3: 'Integer', info4: '通道类型,0不限，1进场，2出场' },
                        { info1: 'showPassMode', info2: '是', info3: 'Integer', info4: '通行模式,0不限，1严，2宽' },
                        { info1: 'showSafeMode', info2: '是', info3: 'Integer', info4: '安全模式,0关闭，1开启' },
                        { info1: 'textMessage', info2: '是', info3: 'String', info4: '显示屏显示信息模板: 如"%P欢迎光临,意为：粤G88888(%p)欢迎光临"。   %PT 代表 停车时长,%P 代表 车牌号,%C 代表 应缴金额,\\ 代表 换行,%ST 代表 停车时长,%TM 代表 时间，精确到秒,%TD 代表 时间，精确到日,%T1S1 代表 停车场1的总剩余车位,%VM 代表 本地VIP别称,%VT 代表 本地VIP剩余天数,%LVT 代表 本地VIP临时续期时间,%VTT 代表 本地VIP剩余次数,%LV 代表 本地VIP临时续的次数,%VB 代表 本地VIP剩余余额' },
                        { info1: 'voiceMessage', info2: '是', info3: 'String', info4: '显示屏显示信息模板: 如"%P欢迎光临,意为：粤G88888(%p)欢迎光临"。   %PT 代表 停车时长,%P 代表 车牌号,%C 代表 应缴金额,\\ 代表 换行,%ST 代表 停车时长,%TM 代表 时间，精确到秒,%TD 代表 时间，精确到日,%T1S1 代表 停车场1的总剩余车位,%VM 代表 本地VIP别称,%VT 代表 本地VIP剩余天数,%LVT 代表 本地VIP临时续期时间,%VTT 代表 本地VIP剩余次数,%LV 代表 本地VIP临时续的次数,%VB 代表 本地VIP剩余余额' },
                        { info1: 'timeperiodType', info2: '是', info3: 'Integer', info4: '时间段类型,  0：时间有效期内，提醒期之前,1：时间有效期内，提醒期内,2:时间有效期外，延时期内,3:时间有效期外，删除期内' },
                        { info1: 'isCharge', info2: '是', info3: 'Integer', info4: '是否需要交费,0:否,1:是' },
                        { info1: 'lastOperator', info2: '是', info3: 'String', info4: '最后编辑操作员' },
                        { info1: 'lastOperateTime', info2: '是', info3: 'String', info4: '最后编辑时间,yyyy-MM-dd HH:mm:ss' },

                        ]
                },
                ],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [

                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/device/setVipShowMsg.vue